module.exports = __webpack_public_path__ + "static/images/members.e70707b4bde6603aa822474bec31eb72.svg";